import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainCard", "cardBody", "footerTable", "dateStatus", "saveBtn", "dateOpen", "7777", "8888", "9999",
                    "dropdownNewDate", "dropdownNewDateMenu", "yearDropdown", "yearInput", "yearList", "saveBtn",
                    "planDropdown", "planDropdownBtn", "planInput", "planList", "saveBtn"]

  connect() {
    this.controllerName = `operations--products--tax-filings--settings--dates`
    this.doDatesListHtml()
  }

  newDate() {
    this.actionMode = "new"
    var newMonth = 0
    var newYear = this.yearInputTarget.dataset.year
    var saveMode = false
    var message = ``
    if (this.application.dates.length == 0) {
      saveMode = true
    } else {
      this.application.dates.forEach(element => {
        if (element.year.toString() == newYear) {
          saveMode = false
          message = `O Ano-Exercício ${Number(newYear) + 1} já existe.`
        } else {
          saveMode = true
        }
      });
    }

    this.send_data = { current_user: {}, product: {}, date: {}, tracker: { manual: true } }

    this.send_data.date.product_id = this.application.tax_filing.id
    this.send_data.date.open = true
    this.send_data.date.month = newMonth
    this.send_data.date.year = newYear
    this.send_data.date.product_plan = this.planInputTarget.dataset.plan

    this.send_data.tracker.obj_type = `operation_dates`
    this.send_data.tracker.action = `created`
    this.send_data.tracker.observations = `Criou a Competência IRPF ${Number(newYear) + 1}`

    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = this.application.date_permission

    if (saveMode) {
      this.requestSave()
    } else {
      this.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", message, 2000)
    }
  }

  changeDateOpen(ev) {
    var dateId = ev.target.closest(".row").dataset.id
    if (ev.target.checked) {
      this.nameTarget(`dateStatus-${dateId}`).innerText = `Aberto`
    } else {
      this.nameTarget(`dateStatus-${dateId}`).innerText = `Fechado`
    }
    this.nameTarget(`saveBtn-${dateId}`).classList.remove("d-none")
  }

  editDate(ev) {
    this.actionMode = "edit"
    var dateId = ev.target.closest(".row").dataset.id
    this.nameTarget(`saveBtn-${dateId}`).classList.add("d-none")

    this.send_data = { current_user: {}, date: {}, tracker: { manual: true } }

    this.send_data.date.product_id = this.application.tax_filing.id
    this.send_data.date.id = dateId
    this.send_data.date.open = this.nameTarget(`dateOpen-${dateId}`).checked

    var current_date = {}
    this.application.dates.forEach(element => {
      if (element.id == dateId) {
        current_date = element
      }
    })

    if (this.nameTarget(`dateOpen-${dateId}`).checked) {
      var phrase = `Abriu a Competência ${current_date.financial_year}`
    } else {
      var phrase = `Fechou a Competência ${current_date.financial_year}`
    }

    this.send_data.tracker.obj_id = dateId
    this.send_data.tracker.obj_type = `operation_dates`
    this.send_data.tracker.action = `updated`
    this.send_data.tracker.observations = `${phrase}`

    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = this.application.date_permission

    this.requestSave()
  }

  requestSave() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal({ message: `Em processamento, aguarde!` })

    this.send_data.tracker.record_id = this.application.tax_filing.id
    this.send_data.tracker.record_type = `operation_products`

    if (this.actionMode == "edit") {
      var url = "/operations/products/tax_filings/dates/update"
      var method = "PUT"
    } else if (this.actionMode == "new") {
      var url = "/operations/products/tax_filings/dates/create"
      var method = "POST"
    }
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          controller.closeNewDate()
          var date = response.data.cln
          if (controller.actionMode == "edit") {
            location.reload()
            if (date.active) {
              controller.application.dates.forEach((element, i) => {
                if (element.id == date.id) {
                  controller.application.dates.splice(controller.application.dates.indexOf(element), 1, date)
                }
              })
              if (controller.application.current_date.id == date.id) {
                controller.application.current_date = date
                if (controller.application.current_date.open == false) {
                  controller.application.current_date.message = `O Ano-Exercício ${controller.application.current_date.year + 1} está fechado.`
                }
              }
            } else {
              controller.application.dates.forEach((element, i) => {
                if (element.id == date.id) {
                  controller.application.dates.splice(controller.application.dates.indexOf(element), 1)
                }
              })
              if (controller.application.current_date.id == date.id) {
                controller.application.current_date = {}
              }
            }
          } else if (controller.actionMode == "new") {
            controller.application.dates[controller.application.dates.length] = date
            location.reload()
          }
          controller.application.current_date = controller.application.dates[0]
          if (controller.application.current_date.open == false) {
            controller.application.current_date = { open: false, not_defined: true, message: `A Competência está fechada` }
          }
          controller.listData()
          controller.closeNewDate()
          controller.getControllerByIdentifier("operations--products--tax-filings--show--dates").doDatesHTML()
        } else {
          // this.nameTarget(`saveBtn-${data.date.id}`).classList.remove("d-none")
        }
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  listData() {
    // var dates = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(this.application.dates, "year")

    var dates = [this.application.current_date]

    this.cardBodyTarget.innerHTML = ""
    if (dates == undefined || dates == [] || dates.length == 0) {
      var noData = `<div class="row d-flex align-items-center">
                      <div class="col-12 my-3 d-flex align-items-center justify-content-center">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <h5 class="mb-0 f-065">Não existem Exercícios</h5>
                      </div>
                    </div>`

      this.cardBodyTarget.innerHTML = noData
    } else {
      dates.forEach(element => {
        this.cardBodyTarget.insertAdjacentHTML("beforeend", this.datePartial(element))
      });
    }
    this.getControllerByIdentifier("app--helpers--elements").tooltip()
  }

  datePartial(element) {
    if (element.open) {
      if (this.application.permissions[this.application.date_permission].can_update) {
        var inputHtml = `<input class="custom-control-input custom-control-input-permission" id="switchDateOpen-${element.id}" data-action="click->${this.controllerName}#changeDateOpen" data-${this.controllerName}-target="dateOpen-${element.id}" type="checkbox" value="true" checked>`
      } else {
        var inputHtml = `<input disabled class="custom-control-input custom-control-input-permission" id="switchDateOpen-${element.id}" data-action="click->${this.controllerName}#changeDateOpen" data-${this.controllerName}-target="dateOpen-${element.id}" type="checkbox" value="true" checked>`
      }
      var status = `Aberto`
    } else {
      if (this.application.permissions[this.application.date_permission].can_update) {
        var inputHtml = `<input class="custom-control-input custom-control-input-permission" id="switchDateOpen-${element.id}" data-action="click->${this.controllerName}#changeDateOpen" data-${this.controllerName}-target="dateOpen-${element.id}" type="checkbox" value="false">`
      } else {
        var inputHtml = `<input disabled class="custom-control-input custom-control-input-permission" id="switchDateOpen-${element.id}" data-action="click->${this.controllerName}#changeDateOpen" data-${this.controllerName}-target="dateOpen-${element.id}" type="checkbox" value="false">`
      }
      var status = `Fechado`
    }

    if (this.application.permissions[this.application.date_permission].can_delete) {
      var deleteBtn = `<button data-action="click->${this.controllerName}#deleteDate" data-${this.controllerName}-target="deleteBtn-${element.id}" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                        <span class="material-icons md-sm md-dark">delete</span>
                        <span class="mc-tooltiptext">Apagar</span>
                      </button>`
    } else {
      var deleteBtn = ``
    }
    var deleteBtn = ``

    var html = `<div class="row d-flex align-items-center" data-id="${element.id}">
                  <div class="col-2 my-3 px-1 d-flex align-items-center">
                    <span class="f-075">${element.year + 1}</span>
                  </div>
                  <div class="col-6 my-3 d-flex align-items-center">
                    <div class="custom-control custom-switch d-flex align-items-center">
                      ${inputHtml}
                      <span class="custom-control-track"></span>
                      <label class="custom-control-label" for="switchDateOpen-${element.id}"></label>
                    </div>
                    <span class="f-075" data-${this.controllerName}-target="dateStatus-${element.id}">${status}</span>
                  </div>
                  <div class="col-2 my-3 px-1 text-right">
                    <button data-action="click->${this.controllerName}#editDate" data-${this.controllerName}-target="saveBtn-${element.id}" type="button" class="btn btn-sm btn-table p-0 d-none mc-tooltip">
                      <span class="material-icons md-sm md-dark">save</span>
                      <span class="mc-tooltiptext">Salvar</span>
                    </button>
                  </div>
                  <div class="col-2 my-3 px-1 text-right">
                    ${deleteBtn}
                  </div>
                </div>`

    return html
  }

  doDatesListHtml() {
    if (this.application.permissions[this.application.date_permission].can_create) {
      var createBtn = `<div class="dropdown mc-tooltip" data-${this.controllerName}-target="dropdownNewDate">
                        <button id="createDateBtn" data-action="click->${this.controllerName}#dropdownNewDate" aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0">
                          <span class="material-icons">add</span>
                        </button>
                        <span class="mc-tooltiptext">Adicionar Novo Exercício</span>
                        <div aria-labelledby="createDateBtn" class="dropdown-menu dropdown-menu-right menu" data-${this.controllerName}-target="dropdownNewDateMenu" style="width:250%">
                          <span class="default dropdown-item py-1">Novo Exercício</span>
                          <div class="row my-2">
                            <div class="col px-2">
                              <div class="form-group">
                                <div class="floating-label floating-label-sm">
                                  <label>Ano-Exercício</label>
                                  <div class="dropdown dropdown-selector" data-controller="app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="yearDropdown">
                                    <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="yearDropdownBtn"><span class="mr-auto w-100 selected-item" id="selected" data-app--helpers--selector-target="input" data-${this.controllerName}-target="yearInput"></span></button>
                                    <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                      <input class="form-control form-control-selector dropdown-search-input" type="text" placeholder="Buscar ...">
                                      <ul class="ul-select" data-${this.controllerName}-target="yearList"></ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row my-2">
                            <div class="col px-2">
                              <div class="form-group">
                                <div class="floating-label floating-label-sm">
                                  <label>Plano</label>
                                  <div class="dropdown dropdown-selector" data-controller="app--helpers--selector" data-app--helpers--selector-target="dropdown" data-${this.controllerName}-target="planDropdown">
                                    <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:29px;" data-app--helpers--selector-target="btn" data-${this.controllerName}-target="planDropdownBtn"><span class="mr-auto w-100 selected-item f-065" id="selected" data-app--helpers--selector-target="input" data-${this.controllerName}-target="planInput"></span></button>
                                    <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                      <input class="form-control form-control-selector f-065" type="text" placeholder="Buscar ...">
                                      <ul class="ul-select" data-${this.controllerName}-target="planList">
                                        <li data-plan="light" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Light</li>
                                        <li data-plan="pro" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Pro</li>
                                        <li data-plan="premium" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Premium</li>
                                        <li data-plan="enterprise" data-action="click->app--helpers--selector#select" data-app--helpers--selector-target="select" class="li-selector dark f-065">Enterprise</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row my-2">
                            <div class="col px-2 text-center d-flex">
                              <button disabled type="button" class="btn btn-primary btn-sm btn-table f-065 py-2" data-action="click->${this.controllerName}#newDate" data-${this.controllerName}-target="saveBtn" data-mode="new">Criar</button>
                              <button type="button" class="close ml-auto f-065" data-dismiss="alert" data-action="click->${this.controllerName}#closeNewDate" aria-label="Close">
                                <span class="text-left f-065">Fechar</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>`
    } else {
      var createBtn = ``
    }


    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Todos os Anos-Exercícios</h6>
                    <div class="card-actions ml-auto py-0">
                      ${createBtn}
                    </div>
                  </div>
                  <div class="card-body py-0" data-${this.controllerName}-target="cardBody"></div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("operations--products--tax-filings--settings--dashboard").datesTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier("app--helpers--elements").tooltip()
      controller.mainCardTarget.style.height = ($(window).height() * 0.35) + "px"
      controller.listData()
    })
  }

  dropdownNewDate() {
    this.dropdownNewDateTarget.classList.add("show")
    this.dropdownNewDateMenuTarget.classList.add("show")
    this.listYear()
  }

  closeNewDate() {
    this.dropdownNewDateTarget.classList.remove("show")
    this.dropdownNewDateMenuTarget.classList.remove("show")
    this.yearListTarget.innerHTML = ``
    this.yearInputTarget.innerText = ``

    this.yearDropdownTarget.parentElement.classList.remove("has-value")
  }

  listYear() {
    var date = new Date();
    var currentYear = date.getFullYear() + 1;

    var listHtml = ``
    var all_years = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3, currentYear - 4]
    // all_years.forEach(element => {
    //   listHtml += `<li data-year="${element - 1}" data-app--helpers--selector-target="select" data-action="click->app--helpers--selector#select click->${this.controllerName}#refreshSaveBtn" class="li-selector dark">${element}</li>`
    // });
    listHtml += `<li data-year="2024" data-app--helpers--selector-target="select" data-action="click->app--helpers--selector#select click->operations--products--tax-filings--settings--dates#refreshSaveBtn" class="li-selector dark">2025</li>`
    listHtml += `<li data-year="2023" data-app--helpers--selector-target="select" data-action="click->app--helpers--selector#select click->operations--products--tax-filings--settings--dates#refreshSaveBtn" class="li-selector dark">2024</li>`
    listHtml += `<li data-year="2020" data-app--helpers--selector-target="select" data-action="click->app--helpers--selector#select click->operations--products--tax-filings--settings--dates#refreshSaveBtn" class="li-selector dark">2021</li>`
    listHtml += `<li data-year="2021" data-app--helpers--selector-target="select" data-action="click->app--helpers--selector#select click->operations--products--tax-filings--settings--dates#refreshSaveBtn" class="li-selector dark">2022</li>`
    listHtml += `<li data-year="2022" data-app--helpers--selector-target="select" data-action="click->app--helpers--selector#select click->operations--products--tax-filings--settings--dates#refreshSaveBtn" class="li-selector dark">2023</li>`
    listHtml += `<li data-year="2025" data-app--helpers--selector-target="select" data-action="click->app--helpers--selector#select click->operations--products--tax-filings--settings--dates#refreshSaveBtn" class="li-selector dark">2026</li>`
    this.yearListTarget.innerHTML = listHtml
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      
      if (controller.yearInputTarget.innerText == "") {
        len += 1
      }

      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = "operations--products--tax-filings--settings--dates"
    this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
